import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query';
import { ToursScheduledRequestDto } from 'common/types/services/api/tours/tours-scheduled-request-dto.type';
import { getAdminScheduledTours } from 'services/api/tours-api.service';
import { ToursScheduledDto } from 'common/types/services/api/tours/tours-scheduled-dto.type';
import { QueryKey } from 'common/enums/query-key';

export default function useAdminScheduledTours(
  params: ToursScheduledRequestDto,
  options?: Omit<
    UndefinedInitialDataOptions<ToursScheduledDto, Error, ToursScheduledDto, (string | ToursScheduledRequestDto)[]>,
    'queryFn' | 'queryKey'
  >,
) {
  return useQuery({
    ...options,
    queryKey: [QueryKey.Tours, 'admin', 'scheduled', params],
    queryFn: () => getAdminScheduledTours(params),
  });
}
